import React from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxOutlinedIcon from "@material-ui/icons/CheckBoxOutlined";
import ReactHtmlParser from "react-html-parser";
import DOMPurify from "dompurify";
import "./EligibilityCheckbox.module.css";

export default function EligibilityCheckbox(props) {
  const {
    question,
    checked,
    handlerCheckboxChange,
    name,
    label,
    required,
    disabled
  } = props;
  
  const questionArray = Array.isArray(question);
  const questionsIds = questionArray ? question.map(element => element.id) : question.id;
  const questionsRequired = questionArray ? question.map(element => element.required) : question.required;
  const questionsShowOnSummary = questionArray ? question.map(element => element.field.showOnSummary) : question.field.showOnSummary;

  const checkboxChange = (e) => {
    const value = e.target.checked;
    const id = Array.isArray(question)
      ? questionsIds
      : question.id
    const showOnSummary = Array.isArray(question)
      ? questionsShowOnSummary
      : question.field.showOnSummary
    handlerCheckboxChange(value, id, showOnSummary, question);
  }

  return (
    <FormControlLabel
      htmlFor={name}
      label={ReactHtmlParser(DOMPurify.sanitize(`${label}`))}
      tabIndex="0"
      onClick={(event) => event.stopPropagation()}
      onFocus={(event) => event.stopPropagation()}
      control={
        <Checkbox
        color="secondary"
        id={name}
        name={name}
        disabled={question.disabled || disabled}
          required={
            Array.isArray(question)
              ? questionsRequired.every(
                (currentValue) => currentValue === true
              )
              : required
          }
          checked={checked || false}
          checkedIcon={<CheckBoxOutlinedIcon />}
          onChange={checkboxChange}
        />
      }
    />
  );
}
